/**
 * Load required plugins
*/

try {
  const contact_form = document.getElementById('contact-form');
  const footer_newsletter = document.getElementById('footer-newsletter');

  if (contact_form || footer_newsletter) {
    window.$ = window.jQuery = require('jquery');
    window.jqueryValidation = require('jquery-validation');

    jQuery.validator.methods.email = function( value, element ) {
      return this.optional(element) || /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
    }

    if (typeof localized !== 'undefined' && localized.locale === 'de') {
      require('jquery-validation/dist/localization/messages_de');
    }
  }
}
catch (e) {
  console.error(e);
}
